import type { DashboardStats, SparklinePoint } from "../../api/contract";
import { apiGet, buildQuery } from "./http";

export function getDashboardStats(): Promise<DashboardStats> {
  return apiGet<DashboardStats>("/api/stats/dashboard");
}

export function getSparkline(minutes = 60): Promise<SparklinePoint[]> {
  return apiGet<SparklinePoint[]>(`/api/stats/sparkline${buildQuery({ minutes })}`);
}
